<template>
  <div class="action-links" >
    <v-speed-dial
      :transition="'slide-x-transition'"
      bottom
      right
      fixed
    >
      <template v-slot:activator>
        <v-btn
          v-model="fab"
          fab
          color="orange"
          class="main-btn"
        >
          <v-icon large>add</v-icon>
        </v-btn>
      </template>
      <v-tooltip
        content-class="bottom"
        bottom
      >
        <v-btn
          slot="activator"
          fab
          small
          color="green"
          @click="onAddAccount"
        >
          <v-icon medium>queue</v-icon>
        </v-btn>
        <span>Create Account</span>
      </v-tooltip>

      <v-tooltip
        content-class="bottom"
        bottom
      >
        <v-btn
          slot="activator"
          fab
          small
          color="green"
          @click="onAddMasterPayer"
        >
          <v-icon medium>note_add</v-icon>
        </v-btn>
        <span>Create MasterPayer</span>
      </v-tooltip>

      <v-tooltip
        content-class="bottom"
        bottom
      >
        <v-btn
          slot="activator"
          fab
          small
          color="#7e7e7e"
          @click="onAddCustomer"
        >
          <v-icon medium>domain</v-icon>
        </v-btn>
        <span>Create Customer</span>
      </v-tooltip>

      <v-tooltip
        content-class="bottom"
        bottom
      >
        <v-btn
          slot="activator"
          fab
          small
          color="#41B3DF"
        >
          <v-icon medium>person_add</v-icon>
        </v-btn>
        <span>Create User</span>
      </v-tooltip>

    </v-speed-dial>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      on: true,
      fab: false
    }
  },
  methods: {

    onAddAccount () {
      this.$store.commit('admin/openAccountDialog', {
        show: true,
        type: 'new',
        submitLabel: 'Create',
        submitHandler: (fields) => {
          this.$store.dispatch('admin/saveNewAccount', fields, { root: true })
        }
      })
    },

    onAddMasterPayer () {
      this.$store.commit('admin/openMasterPayerDialog', {
        show: true,
        type: 'new',
        submitHandler: (fields) => {
          this.$store.dispatch('admin/saveNewMasterPayer', fields, { root: true })
        }
      })
    },

    onAddCustomer () {
      this.$store.commit('admin/clearCustomerDialog')
      this.$store.commit('admin/openCustomerDialog', {
        show: true,
        type: 'new',
        isSingleMp: false,
        submitLabel: 'Create',
        submitHandler: (fields) => {
          this.$store.dispatch('admin/saveNewCustomer', fields)
        }
      })
    }

  }
}
</script>
<style lang="scss">

.action-links {

  .main-btn {
    width: 50px;
    height: 60px;
    border-radius: 50%;
  }

  .v-speed-dial--bottom:not(.v-speed-dial--absolute) {
    bottom: 40px !important;
    right: 45px !important;
  }

  .v-speed-dial--right {
    right: 30px !important
  }

  .v-btn--floating.v-btn--small {
    border-radius: 50%
  }

  .v-btn .v-btn__content .v-icon {
    color: #fff;
  }
}

.v-tooltip__content {
    // right: 100px !important;
    right: -20px !important;
    max-width: 130px !important;
  }
</style>
